import { Lookup } from "./Lookup"

export interface MasterWorkoutExercise {
    id?: number
    masterWorkoutId: number
    masterGroupId?: number
    masterGroupName?: string
    masterExerciseId?: number
    masterExerciseName?: string
    masterExerciseOptionIds?: string[]
    sets?: number
    calculatedWeight?: number
    reps?: number
    week: number
    day: number
    repRange?: string
    rir?: string
    tempo?: string
    rest?: string
    intensityTechnique?: string
    percentageOfMax?: number
    maxConservative?: number
    maxModerate?: number
    maxHigh?: number
    multiplier?: number
    note?: string
    displayOrder?: number
    resultListOrder?: number
    masterWorkoutExerciseGroupAccessTermIds?: number[]
    masterWorkoutExerciseGroupFilterTermIds?: number[]
    masterWorkoutExerciseSets?: MasterWorkoutExerciseSet[]
}

export interface MasterWorkoutExerciseSet {
    id?: number
    displayOrder?: number
    note?: string
    isChild?: boolean
    isToFailure?: boolean
    reps?: number
    rir?: number
    masterWorkoutExerciseId?: number
}

export interface API_UpdateMasterWorkoutExerciseOrderRequest {
    id: number
    order: number
    day: number
}

export interface API_SubmitMasterWorkoutExercisesRequest {
    masterWorkoutExercises?: MasterWorkoutExercise[]
    deletedMasterWorkoutExerciseIds?: number[]
    masterWorkoutId: number
}

export interface GroupedMasterWorkoutExercises {
    [key: string]: {
        [key: string]: MasterWorkoutExercise
    }
}

export interface MasterExerciseLookup extends Lookup {
    masterExerciseGroupMainId: number
    masterExerciseGroupAccessTermIds: number[],
    masterExerciseGroupFilterTermIds: number[],
}

export interface MasterWorkoutExerciseLookups {
    masterExercises: MasterExerciseLookup[];
    masterGroups: Lookup[];
    groupAccessTerms: Lookup[];
    groupFilterTerms: Lookup[];
}

export enum IntensityTechniques {
    amrap = 'Amrap',
    bloodFlowRestriction = 'Blood Flow Restriction',
    circuit = 'Circuit',
    dropSet = 'DropSet',
    eccentricOverload = 'Eccentric Overload',
    isoHold = 'IsoHold',
    myoReps = 'MyoReps',
    pyramid = 'Pyramid',
    restPause = 'Rest Pause',
    superSet = 'SuperSet',
    timeUnderTension = 'Time Under Tension',
    twentyOnes = 'TwentyOnes',
}